<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <div class="u-max-700 u-center-block">
                <page-header>
                    <slot slot="title">{{ $t('customer.account.backorders.title') }}</slot>
                    <slot slot="description">
                        <p v-html="IntroBackorders"></p>
                    </slot>
                </page-header>
                <section class="c-form-row o-page-bottom-spacing--medium u-center-block">
                    <div v-for="order in CustomerBackOrders" :key="order.OrderNumber" class="u-margin-bottom">
                        <v-order-line :order="order" :to="`/customer/account/backorders/detail/${order.Id}`"></v-order-line>
                    </div>
                    <v-empty-state v-if="!CustomerBackOrders || CustomerBackOrders.length == 0">
                        <slot slot="title">{{ $t('customer.account.history.no_orders') }}</slot>
                    </v-empty-state>
                </section>
            </div>
        </slot>
    </sidebar-left>
</template>

<script>

    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'
    import VLoading from '@/components/Loading'
    import VEmptyState from '@/components/EmptyState'
    import VOrderLine from '@/components/order/OrderLine'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VLoading,
            VEmptyState,
            VOrderLine,
        },
        data() {
            return {
                loaded: {}
            }
        },
        created(){
            this.$store.dispatch('getCustomerBackOrders').then(() => {
                this.loaded = { isLoaded: true }
            }).catch(() => {
                this.loaded = { isLoaded: true }
                this.$notify({
                    group: 'global',
                    title: 'Er heeft zich een technisch probleem voorgedaan.',
                    type: 'error',
                    duration: 2000
                });
            })
        },
        computed: {
            ...mapGetters({
                CustomerBackOrders: 'customerBackOrders'
            }),
            IntroBackorders() {
                return this.$t('intro.customer_account_backorders');
            },
            sideMenuLinks() {
                let menu = [
                    {
                        title: 'customer.account.edit.title',
                        route: '/customer/account/edit',
                    }
                ];

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.users.title',
                        route: '/customer/account/users'
                    });
                    menu.push({
                        title: 'customer.account.addresses.title',
                        route: '/customer/account/addresses'
                    });
                }

                if(this.isCustomer || this.isMarketing) {
                    menu.push({
                        title: 'customer.account.history.title',
                        route: '/customer/account/history'
                    });

                    menu.push({
                        title: 'customer.account.backorders.title',
                        route: '/customer/account/backorders'
                    })
                }

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.invoices.title',
                        route: '/customer/account/invoices'
                    });
                }

              return menu;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        },
        methods: { }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/customer/account/Backorders.vue